import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import CreateEmployeeForm from './create-employee-form/create-employee-form';
import EmployeesListing from './employees-listing/employees-listing';
import { DataResources, ResourceActionType, user_has_data_model_access } from '../../../utils/permissions';

function Employees() {
  const { user, config } = useContext(AuthContext);

  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Employees
        </Typography>

        <Grid container spacing={2}>
          <Grid xs={4}></Grid>
          <Grid xs={4}></Grid>
          <Grid xs={4} sx={{ textAlign: 'right' }}>
            <CreateEntityDrawer disabled={!user_has_data_model_access(user, DataResources.EMPLOYEE, ResourceActionType.CREATE)}>
              <CreateEmployeeForm />
            </CreateEntityDrawer>
          </Grid>
          <Grid xs={12}>
            <EmployeesListing />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Employees;
